<script lang="ts">
    import TestimonialSliderView from './TestimonialSlider.View.svelte';

    import type { Layout } from '$lib/types/Components/SharedTypes';
    import type { TestimonialSliderContent } from '$lib/types/Components/TestimonialSlider/TestimonialSliderContent';
    import type { Language } from '$lib/types/Language';
    import type { TransitionEffect } from '$lib/types/Theme';

    export let id = '';
    export let content: TestimonialSliderContent;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let layout: Layout;
    export let language: Language = 'en';
</script>

<TestimonialSliderView
    {id}
    testimonials={content.testimonials}
    framed={content.framed}
    bgColor={content.box.backgroundColor}
    {transitionDelay}
    {transitionEffect}
    {layout}
    {language}
/>
